import { Directive, ElementRef, Input, OnInit } from "@angular/core";

@Directive({
  selector: "img[cdnSrc]",
})
export class CdnImageDirective implements OnInit {
  @Input("src") src!: string;
  @Input() cdnWidth?: number;
  @Input() cdnHeight?: number;

  constructor(private el: ElementRef<HTMLImageElement>) {}

  ngOnInit() {
    if (!this.src) return;

    const imgEl = this.el.nativeElement;
    let finalUrl = this.src.trim();

    // ✅ Case 1: IQMetrix CDN (existing logic)
    if (this.src.startsWith("https://ams.iqmetrix.net/images/")) {
      const base = this.src.replace(/\/+$/, "");
      let previewUrl = `${base}/preview`;

      if (this.cdnWidth && this.cdnHeight) {
        previewUrl += `/${this.cdnWidth}/${this.cdnHeight}`;
      } else if (this.cdnWidth) {
        previewUrl += `/${this.cdnWidth}`;
      }

      // Try preview first
      imgEl.src = previewUrl;

      // Fallback if preview 404s or fails
      imgEl.onerror = () => {
        imgEl.src = this.src;
        imgEl.onerror = null;
      };
      return;
    }

   if (
     this.src.includes("cova-common.s3.ca-central-1.amazonaws.com") ||
     this.src.includes("cova-common.s3.amazonaws.com")
   ) {
     const s3Base = "https://cova-common.s3.ca-central-1.amazonaws.com";
     const s2Base = "https://cova-common.s3.amazonaws.com";
     const cloudfrontBase = "https://d1t0ab30i9xkzc.cloudfront.net";
     const relativePath = this.src
       .replace(s3Base, "")
       .replace(s2Base, "")
       .replace(/^\/+/, ""); // remove leading slashes

     const width = this.cdnWidth || 800;
     const height = this.cdnHeight || 600;

     // Example:
     // https://d1drpnp9kmat2v.cloudfront.net/fit-in/1440x500/filters:quality(70)/filters:format(webp)/compressed/image.jpg
     // finalUrl = `${cloudfrontBase}/fit-in/${width}x${height}/filters:quality(90)/filters:format(webp)/filters:strip_exif()/filters:no_upscale()/${relativePath}`;
     finalUrl = `${cloudfrontBase}/filters:format(webp)/filters:strip_exif()/${relativePath}`;
   }

    // ✅ Default fallback
    imgEl.src = finalUrl;
  }
}
